// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sanomatSans_23e4e7', '__sanomatSans_Fallback_23e4e7'"},"className":"__className_23e4e7","variable":"__variable_23e4e7"};